import { GENERIC_ERROR_EVENT } from "core-lib/constants/common";
import { ErrorObjectType, ErrorUiTypeEnum } from "ui-v2/types/Error";
import { isServer } from "./utils";

export const genericErrorHandler = (errorResponse) => {
  let errorObj: ErrorObjectType = errorResponse?.data?.err_obj;
  if (!errorObj) {
    errorObj = {
      ui_type:
        errorResponse?.data?.err_obj?.ui_type ?? ErrorUiTypeEnum.toast_info,
      title: typeof(errorResponse?.data?.message) === 'string' ? errorResponse?.data?.message : "Error",
    };
  }
  if (!isServer()) {
    const errorEvent = new CustomEvent(GENERIC_ERROR_EVENT, {
      detail: errorObj,
    });
    window.dispatchEvent(errorEvent);
  }
};
